import React, { useCallback, useEffect, useRef, useState } from "react";
import homrbg from "../images/home-bg-video.mp4";
import whychoosebgimg from "../images/why-choose-bgimg.svg";
import whychoosecolor from "../images/why-choose-color.png";
import testimonialstitlebg from "../images/testimonials-title-bg.png";
import closeIcon from "../images/closeIcon.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import traderegistrationbg from "../images/trade-registration-bg.png";
import Header from "./common/Header";
import Footer from "./common/Footer";
import { Link } from "react-router-dom";
import { handleToggleCollapse } from "./common/Collapsfunction";
import { callApi } from "./common/API/Api";
import { useTranslation } from "react-i18next";
import "../i18n";
import axios from "axios";
import { getBaseUrl } from "./common/BaseUrl";
 

const Home = () => {
  const { t } = useTranslation();
  let base_image_url = process.env.REACT_APP_IMAGE_URL;
  const [activeAnimation, setActiveAnimation] = useState("");
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [homepagedata, setHomepagedata] = useState();
  const [cryptoData, setCryptoData] = useState([]);
  const [forexData, setForexData] = useState([]);
  const [collapseshow, setCollapseshow] = useState();
  const [loaddata, setLoaddata] = useState(true);
  const [reviewdata, setReviewdata] = useState([]);
  const token = localStorage.getItem("token");
  let base_url = getBaseUrl();
  const handleMouseEnter = (animationClass) => {
    setActiveAnimation(animationClass);
  };

  const handleMouseLeave = () => {
    setActiveAnimation("");
  };

  function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
      const mql = window.matchMedia(query);
      const handler = (e) => setMatches(e.matches);
      mql.addEventListener("change", handler);
      setMatches(mql.matches);
      return () => mql.removeEventListener("change", handler);
    }, [query]);
    return matches;
  }

  const isDesktop = useMediaQuery("(min-width: 1402px)");
  const wrapperRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    if (!isDesktop) return;
    const handleScroll = () => {
      setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
    };

    const handleResize = () => {
      if (wrapperRef.current) {
        document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      }
    };

    // Initial setup
    if (wrapperRef.current) {
      document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      document.body.style.overflow = "auto";

      wrapperRef.current.style.transition = "transform 0.3s ease-out";
      wrapperRef.current.style.position = "fixed";
      wrapperRef.current.style.top = "0";
      wrapperRef.current.style.left = "0";
      wrapperRef.current.style.width = "100%";
      wrapperRef.current.style.padding = "0";
      wrapperRef.current.style.zIndex = "2";
      wrapperRef.current.style.display = "block";
      wrapperRef.current.style.backfaceVisibility = "hidden";
    }

    // Add scroll and resize listeners
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, wrapperRef?.current?.offsetHeight]);

  // Apply scroll effect to the wrapper
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
    }
  }, [scrollTop]);
  useEffect(() => {
    document.body.style.backgroundColor = "#000000";
    return () => {
      document.body.style = {};
    };
  }, []);
 
 const homepagecontent = useCallback(async () => {
  try {
    let langcode = base_url.split("/")[1]
    let postdata = {};
    let res = await callApi(
      postdata,
      `api/get-home-page?lang=${langcode}`,
      "GET"
    );

    if (res?.data?.success) {
      setHomepagedata(res?.data?.data);
    }
  } catch (err) {
    console.log(err, "err");
  } finally {
    setLoaddata(false);
  }
}, [base_url]);

useEffect(() => {
    homepagecontent();
}, [homepagecontent]);
  const BreakText = ({ text, breakAt }) => {
    const splitText = (text, breakAt) => {
      if (!text) return;
      const words = text?.split(" ");
      const beforeBreak = words.slice(0, breakAt)?.join(" ");
      const afterBreak = words.slice(breakAt)?.join(" ");
      return (
        <>
          {beforeBreak}
          <br />
          {afterBreak}
        </>
      );
    };

    return splitText(text, breakAt);
  };
  const settings = {
    centerMode: true,
    slidesToShow: 1,
    autoplay: false,
    centerPadding: "0px",
    autoplaySpeed: 4000,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
        },
      },
    ],
  };
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Formats as YYYY-MM-DD
  };
 const cryptos = [
    { symbol: "XRP", name: "XRP", image: "/noindex-images/xrp.svg" },
    { symbol: "SOL", name: "Solana", image: "/noindex-images/solana.svg" },
    { symbol: "BTC", name: "Bitcoin", image: "/noindex-images/bitcoin-icon.svg" },
    { symbol: "USDT", name: "Tether", image: "/noindex-images/tether.svg" },
    { symbol: "AVAX", name: "Avalanche", image: "/noindex-images/avalanche.svg" },
  ];

  const generateRandomTrendData = (start, isUp, points = 12) => {
    const data = [start];
    let current = start;

    for (let i = 1; i < points; i++) {
      const variance = start * 0.015; // 1.5% movement
      const change = Math.random() * variance * (isUp ? 1 : -1);

      current += change + (Math.random() - 0.5) * variance * 0.6;
      data.push(Number(current.toFixed(2)));
    }

    return data;
  };
  const generateCurvedPath = (
    data,
    width = 84,
    height = 37,
    padding = 2,
    tension = 0.5,
  ) => {
    if (data.length < 2) return "";

    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const stepX = (width - padding * 2) / (data.length - 1);

    const points = data.map((value, index) => ({
      x: padding + index * stepX,
      y: height - padding - ((value - min) / range) * (height - padding * 2),
    }));

    let d = `M ${points[0].x} ${points[0].y}`;

    for (let i = 0; i < points.length - 1; i++) {
      const p0 = points[i - 1] || points[i];
      const p1 = points[i];
      const p2 = points[i + 1];
      const p3 = points[i + 2] || p2;

      const cp1x = p1.x + ((p2.x - p0.x) / 6) * tension;
      const cp1y = p1.y + ((p2.y - p0.y) / 6) * tension;

      const cp2x = p2.x - ((p3.x - p1.x) / 6) * tension;
      const cp2y = p2.y - ((p3.y - p1.y) / 6) * tension;

      d += ` C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${p2.x} ${p2.y}`;
    }

    return d;
  };
  const PolygonDailyOpenClose = async () => {
    try {
      const currentDate = getCurrentDate();
      const apiKey = process.env.REACT_APP_API_KEY; // Replace with your actual API key

      const requests = cryptos.map((crypto) =>
        axios.get(
          `https://api.polygon.io/v1/open-close/crypto/${crypto.symbol}/USD/${currentDate}`,
          {
            params: { adjusted: true, apiKey },
          },
        ),
      );

      const responses = await Promise.all(requests); // Fetch all requests in parallel

      const data = responses
        .map((res, index) => {
          try {
            const open = res?.data?.open;
            const close = res?.data?.close;
            if (res?.data?.closingTrades?.length === 0) {
              return null;
            }
            // ❌ If no valid prices → remove this index
            if (!open || !close) {
              return null;
            }

            const percentageChange = ((close - open) / open) * 100;
            const isUp = close > open;

            const randomCloseData =
              typeof generateRandomTrendData === "function"
                ? generateRandomTrendData(open, isUp, 14)
                : [];

            const curvedPath =
              typeof generateCurvedPath === "function"
                ? generateCurvedPath(randomCloseData)
                : "";

            const gradientId = `spark-${cryptos?.[index]?.symbol}-${index}`;

            return {
              ...cryptos[index],
              open,
              close,
              percentageChange: Number.isFinite(percentageChange)
                ? percentageChange.toFixed(2)
                : "0.00",
              isUp,
              sparkline: {
                path: curvedPath,
                strokeColor: isUp ? "#16C784" : "#FF1942",
                gradientId,
              },
            };
          } catch (err) {
            console.log("Crypto mapping error:", err);
            return null; // remove on error
          }
        })
        .filter(Boolean);

      return data;
    } catch (err) {
      console.log(err, "API Error");
      return [];
    }
  };
useEffect(() => {
  const fetchData = async () => {
    const data = await PolygonDailyOpenClose();
    setCryptoData(data);
  };

  fetchData();
}, []);
 const forexPairs = [
    {
      pair: "EUR/USD",
      from: "EUR",
      to: "USD",
      image: "/noindex-images/eurusd.svg",
      ticker: "C:EURUSD",
    },
    {
      pair: "CAD/JPY",
      from: "CAD",
      to: "JPY",
      image: "/noindex-images/CADJPY.svg",
      ticker: "C:CADJPY",
    },
    {
      pair: "AUD/JPY",
      from: "AUD",
      to: "JPY",
      image: "/noindex-images/AUDJPY.svg",
      ticker: "C:AUDJPY",
    },

    {
      pair: "EUR/JPY",
      from: "EUR",
      to: "JPY",
      image: "/noindex-images/EURJPY.svg",
      ticker: "C:EURJPY",
    },
    {
      pair: "GBP/JPY",
      from: "GBP",
      to: "JPY",
      image: "/noindex-images/GBPJPY.svg",
      ticker: "C:GBPJPY",
    },
  ];
 
  const fetchForexData = async () => {
    try {
      const currentDate = getCurrentDate();
      const apiKey = process.env.REACT_APP_API_KEY;

      const requests = forexPairs.map((forex) =>
        axios
          .get(
            `https://api.polygon.io/v2/aggs/ticker/${forex?.ticker}/range/1/day/${currentDate}/${currentDate}`,
            {
              params: { adjusted: true, apiKey },
            },
          )
          .catch((error) => {
            console.log(`Error fetching ${forex?.ticker}`, error);
            return null; // prevent Promise.all failure
          }),
      );

      const responses = await Promise.all(requests);

      const data = responses
        .map((res, index) => {
          try {
            const result = res?.data?.results?.[0];

            // ❌ If no candle data → remove item
            if (!result?.o || !result?.c) {
              return null;
            }

            const open = result.o;
            const close = result.c;

            const percentageChange = ((close - open) / open) * 100;
            const isUp = close > open;

            const randomCloseData =
              typeof generateRandomTrendData === "function"
                ? generateRandomTrendData(open, isUp, 14)
                : [];

            const curvedPath =
              typeof generateCurvedPath === "function"
                ? generateCurvedPath(randomCloseData)
                : "";

            const gradientId = `spark-${forexPairs?.[index]?.symbol}-${index}`;

            return {
              ...forexPairs[index],
              open,
              close,
              percentageChange: Number.isFinite(percentageChange)
                ? percentageChange.toFixed(2)
                : "0.00",
              isUp,
              sparkline: {
                path: curvedPath,
                strokeColor: isUp ? "#16C784" : "#FF1942",
                gradientId,
              },
            };
          } catch (innerErr) {
            console.log("Mapping Error:", innerErr);
            return null; // remove on error
          }
        })
        .filter(Boolean); // ✅ removes all null items

      return data;
    } catch (err) {
      console.log("fetchForexData Error:", err);
      return forexPairs; // keep existing list
    }
  };

  useEffect(() => {
    fetchForexData().then((data) => setForexData(data));
  }, []);
  let mixedData = [
    ...forexData.slice(0, 2), // top 2 from forex
    ...cryptoData.slice(0, 3), // top 3 from crypto
  ];

  const getreviewdata = useCallback(async ()=>{
try {
      let postdata = {};
       let langcode = base_url.split("/")[1]
      let res = await callApi(
        postdata,
        `api/get-review-page?lang=${langcode}`,
        "GET",
      );
      if (res?.data?.success) {
        if (res?.data?.data?.ReviewData?.length === 1) {
          setReviewdata([
            res?.data?.data?.ReviewData[0],
            { ...res?.data?.data?.ReviewData[0] },
          ]);
        } else {
          setReviewdata(res?.data?.data?.ReviewData);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  },[base_url])
 
  useEffect(() => {
    getreviewdata();
  }, [getreviewdata]);

  useEffect(() => {
    if (homepagedata?.meta?.meta_title) {
      document.title = homepagedata?.meta?.meta_title || "Equlix";

      const descriptionMeta = document.querySelector(
        "meta[name='description']",
      );
      if (descriptionMeta) {
        descriptionMeta.setAttribute(
          "content",
          homepagedata?.meta?.meta_description || "",
        );
      } else {
        const meta = document.createElement("meta");
        meta.name = "description";
        meta.content = homepagedata?.meta?.meta_description || "";
        document.head.appendChild(meta);
      }

      const keywordsMeta = document.querySelector("meta[name='keywords']");
      if (keywordsMeta) {
        keywordsMeta.setAttribute(
          "content",
          homepagedata?.meta?.meta_keywords || "",
        );
      } else {
        const meta = document.createElement("meta");
        meta.name = "keywords";
        meta.content = homepagedata?.meta?.meta_keywords || "";
        document.head.appendChild(meta);
      }
    } else {
      document.title = "Equlix";
    }
  }, [homepagedata]);
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
     console.log("beforeinstallprompt inner");
    };
  console.log("beforeinstallprompt outer");
    window.addEventListener("beforeinstallprompt", handler);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);
  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    setDeferredPrompt(null);
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult.outcome === "accepted") {
      console.log("User accepted install");
    } else {
      console.log("User dismissed install");
      setDeferredPrompt(null);
    }

    setDeferredPrompt(null);
  };
  return (
    <div className={`home ${deferredPrompt && "active"}`}>
      <div className="main-page w-100" ref={wrapperRef}>
        <div className={`top-header ${deferredPrompt && "active"}`}>
          <div className="container">
            <div className="top-header-inner">
              <div className="text-box">
                <span
                  className="close-btn"
                  onClick={() => setDeferredPrompt(null)}
                >
                  <img src={closeIcon} alt="closeIcon" />
                </span>
                <h6 className="mb-0">
                  {t("Would you like to add Equlix to your home screen")}
                </h6>
              </div>

              <div className="btn-actions">
                <button
                  className="site_grdbtn btn"
                  onClick={() => handleInstall()}
                >
                  {t("Get App")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <Header />
        {/* Home-area start */}
        <section className="hero-banner hero-banner-2">
          <div className="bg-animation">
            <div className="video-wrapper">
              <video playsInline loop muted autoPlay>
                <source src={homrbg} type="video/mp4" />
              </video>
            </div>
          </div>
          <div className="container">
            <div className="bannermlslide">
              <div className="row align-items-center">
                <div className="col-xl-12">
                  <div className="banner-content">
                    <h1 className="banner-title">
                      <BreakText
                        text={homepagedata?.bannerSection?.title?.title}
                        breakAt={2}
                      />
                      {/* From Dreams
                    <br />
                    To Trades */}
                    </h1>
                    <p>{homepagedata?.bannerSection?.subtitle?.subtitle}</p>
                    <div className="open_acco">
                      <Link
                        className="btn site_grdbtn"
                        to={
                          token
                            ? `${base_url}userdashboard`
                            : homepagedata?.bannerSection?.content
                                ?.button_first_link
                        }
                        state={token ? { from: "real_account" } : ""}
                      >
                        {homepagedata?.bannerSection?.content?.button_first}
                      </Link>
                      <Link
                        className="btn site_grdbtn"
                        to={
                          token
                            ? `${base_url}userdashboard`
                            : homepagedata?.bannerSection?.content
                                ?.button_second_link
                        }
                        state={token ? { from: "real_account" } : ""}
                      >
                        {homepagedata?.bannerSection?.content?.button_second}
                      </Link>
                    </div>
                    <div className="video_thumbnail">
                      <div className="video-wrapper">
                        {homepagedata?.bannerSection?.content?.video_link ? (
                          <video
                            playsInline
                            loop
                            muted
                            autoPlay
                            webkit-playsinline="true"
                            preload="auto"
                          >
                            <source
                              src={
                                homepagedata.bannerSection.content.video_link
                              }
                              type="video/mp4"
                            />
                          </video>
                        ) : (
                          <p>{t("Loading video...")}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Home-area end  */}

        {/* What is Equlix? start  */}
        <section className="whatEqulix_Sec secPadding">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="sec_title text-center">
                  <h2 className="block_title">
                    {homepagedata?.aboutSections[0]?.title?.title}
                  </h2>
                  <p>{homepagedata?.aboutSections[0]?.subtitle?.subtitle}</p>
                </div>
              </div>
            </div>
            <div className="row bgColorbefore">
              <div className="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div className="ourPlatform_box">
                  <div className="ourPlatform_box_inner">
                    <div>
                      <figure>
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            homepagedata?.aboutSections[0]?.content?.image
                          }
                          alt="what-equlix01.svg"
                        />
                      </figure>
                      <h5>
                        <BreakText
                          text={homepagedata?.aboutSections[0]?.content?.title}
                          breakAt={3}
                        />

                        {/* Wide Range of
                    <br />
                    Instruments */}
                      </h5>
                      <p>
                        {homepagedata?.aboutSections[0]?.content?.description}
                      </p>
                    </div>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {" "}
                      <i className="fa-solid fa-arrow-right"></i>View More
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div className="ourPlatform_box">
                  <div className="ourPlatform_box_inner">
                    <div>
                      <figure>
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            homepagedata?.aboutSections[1]?.content?.image
                          }
                          alt="what-equlix02.svg"
                        />
                      </figure>
                      <h5>
                        <BreakText
                          text={homepagedata?.aboutSections[1]?.content?.title}
                          breakAt={1}
                        />

                        {/* Advanced
                    <br />
                    Trading Tools */}
                      </h5>
                      <p>
                        {homepagedata?.aboutSections[1]?.content?.description}
                      </p>
                    </div>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {" "}
                      <i className="fa-solid fa-arrow-right"></i> View More
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div className="ourPlatform_box">
                  <div className="ourPlatform_box_inner">
                    <div>
                      <figure>
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            homepagedata?.aboutSections[2]?.content?.image
                          }
                          alt="what-equlix03.svg"
                        />
                      </figure>
                      <h5>
                        <BreakText
                          text={homepagedata?.aboutSections[2]?.content?.title}
                          breakAt={1}
                        />
                      </h5>
                      <p>
                        {homepagedata?.aboutSections[2]?.content?.description}
                      </p>
                    </div>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {" "}
                      <i className="fa-solid fa-arrow-right"></i> View More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* What is Equlix? end */}
        {/* ourPlatform start */}
        <section className="ourPlatform_Sec secPadding">
          <div className="container topBorder">
            <div className="row">
              <div className="col-xl-12">
                <div className="sec_title text-left">
                  <h2 className="block_title">
                    {" "}
                    {homepagedata?.keyFeatureSection[0]?.title?.title}
                  </h2>
                  <p>
                    {homepagedata?.keyFeatureSection[0]?.subtitle?.description}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 mb-4">
                <div className="ourPlatform_box">
                  <div className="inner_box">
                    <div>
                      <figure>
                        <img
                          src={
                            base_image_url +
                            homepagedata?.keyFeatureSection[0]?.content?.icon
                          }
                          alt="Our Platform Icon"
                        />
                      </figure>
                      <h5>
                        {homepagedata?.keyFeatureSection[0]?.content?.title}
                      </h5>
                      <p>
                        {
                          homepagedata?.keyFeatureSection[0]?.content
                            ?.description
                        }
                      </p>
                    </div>
                    <Link to={`${base_url}signup`}>
                      {t("Sign up")} <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-8 mb-4">
                <div className="ourPlatform_box">
                  <div className="inner_box">
                    <div>
                      <figure>
                        <img
                          src={
                            base_image_url +
                            homepagedata?.keyFeatureSection[1]?.content?.icon
                          }
                          alt="Our Platform Icon"
                        />
                      </figure>
                      <h5>
                        {homepagedata?.keyFeatureSection[1]?.content?.title}
                      </h5>
                      <p>
                        {
                          homepagedata?.keyFeatureSection[1]?.content
                            ?.description
                        }
                      </p>
                    </div>
                    <Link
                      to=""
                      onClick={(e) => e.preventDefault()}
                      className="leftSide"
                    >
                      <i className="fa-solid fa-arrow-right"></i>{" "}
                      {homepagedata?.keyFeatureSection[1]?.content?.button}
                    </Link>
                  </div>
                  <div className="imgcol">
                    <img
                      src={
                        base_image_url +
                        homepagedata?.keyFeatureSection[1]?.content?.image
                      }
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 mb-4">
                <div className="ourPlatform_box bottom_image">
                  <div className="inner_box">
                    <div>
                      <figure>
                        <img
                          src={
                            base_image_url +
                            homepagedata?.keyFeatureSection[2]?.content?.icon
                          }
                          alt="Our Platform Icon"
                        />
                      </figure>
                      <h5>
                        <BreakText
                          text={
                            homepagedata?.keyFeatureSection[2]?.content?.title
                          }
                          breakAt={3}
                        />
                        {/* Fast & Secure
                      <br />
                      Transactions */}
                      </h5>
                      <p>
                        {
                          homepagedata?.keyFeatureSection[2]?.content
                            ?.description
                        }
                      </p>
                    </div>
                    <Link
                      to=""
                      onClick={(e) => e.preventDefault()}
                      className="leftSide"
                    >
                      {homepagedata?.keyFeatureSection[2]?.content?.button}{" "}
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>
                  <div className="imgcol">
                    <img
                      src={
                        base_image_url +
                        homepagedata?.keyFeatureSection[2]?.content?.image
                      }
                      alt=""
                    />
                    <div className="animate-width"></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-8">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="ourPlatform_box">
                      <div className="inner_box">
                        <div>
                          <figure>
                            <img
                              src={
                                base_image_url +
                                homepagedata?.keyFeatureSection[3]?.content
                                  ?.icon
                              }
                              alt="Our Platform Icon"
                            />
                          </figure>
                          <h5>
                            <BreakText
                              text={
                                homepagedata?.keyFeatureSection[3]?.content
                                  ?.title
                              }
                              breakAt={1}
                            />
                            {/* 24/7
                          <br />
                          Support */}
                          </h5>
                          <p>
                            {
                              homepagedata?.keyFeatureSection[3]?.content
                                ?.description
                            }
                          </p>
                        </div>
                        <Link
                          to=""
                          onClick={(e) => e.preventDefault()}
                          className=""
                        >
                          {homepagedata?.keyFeatureSection[3]?.content?.button}{" "}
                          <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="ourPlatform_box">
                      <div className="inner_box">
                        <div>
                          <figure>
                            <img
                              src={
                                base_image_url +
                                homepagedata?.keyFeatureSection[4]?.content
                                  ?.icon
                              }
                              alt="Our Platform Icon"
                            />
                          </figure>
                          <h5>
                            <BreakText
                              text={
                                homepagedata?.keyFeatureSection[4]?.content
                                  ?.title
                              }
                              breakAt={2}
                            />
                            {/* Advanced Trading
                          <br />
                          Indicators */}
                          </h5>
                          <p>
                            {
                              homepagedata?.keyFeatureSection[4]?.content
                                ?.description
                            }
                          </p>
                        </div>
                        <Link
                          to=""
                          onClick={(e) => e.preventDefault()}
                          className=""
                        >
                          {homepagedata?.keyFeatureSection[4]?.content?.button}{" "}
                          <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 mb-4">
                    <div className="ourPlatform_box">
                      <div className="inner_box">
                        <div>
                          <figure>
                            <img
                              src={
                                base_image_url +
                                homepagedata?.keyFeatureSection[5]?.content
                                  ?.icon
                              }
                              alt="Our Platform Icon"
                            />
                          </figure>
                          <h5>
                            {homepagedata?.keyFeatureSection[5]?.content?.title}
                          </h5>
                          <p>
                            {
                              homepagedata?.keyFeatureSection[5]?.content
                                ?.description
                            }
                          </p>
                        </div>
                        <Link
                          to=""
                          onClick={(e) => e.preventDefault()}
                          className="leftSide"
                        >
                          {homepagedata?.keyFeatureSection[5]?.content?.button}{" "}
                          <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                      </div>
                      <div className="imgcol backgroundImage">
                        {/* <video playsinline loop muted autoplay>
                                  <source src="images/bonus-offers.mp4" type="video/mp4">
                               </video>  */}
                        <img
                          src={
                            base_image_url +
                            homepagedata?.keyFeatureSection[5]?.content?.image
                          }
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ourPlatform end  */}
        {/* Trade the Markets You Love start */}
        <section className="tradeMarkets_Sec">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="sec_title text-center">
                  <h2 className="block_title">
                    <BreakText
                      text={homepagedata?.tradeMarketSection?.title?.title}
                      breakAt={3}
                    />
                    {/* Trade the Markets
                  <br />
                  You Love */}
                  </h2>
                  <p>
                    {homepagedata?.tradeMarketSection?.subtitle?.description}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="tradeMarkets_table">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home"
                        type="button"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        <span>
                          {" "}
                          {
                            homepagedata?.tradeMarketSection?.content
                              ?.first_button
                          }
                        </span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#profile"
                        type="button"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                      >
                        <span>
                          {
                            homepagedata?.tradeMarketSection?.content
                              ?.second_button
                          }
                        </span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="contact-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#contact"
                        type="button"
                        role="tab"
                        aria-controls="contact"
                        aria-selected="false"
                      >
                        <span>
                          {
                            homepagedata?.tradeMarketSection?.content
                              ?.third_button
                          }
                        </span>
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <div className="table-responsive">
                        <ul className="tradeMarkets_table_list">
                          {mixedData?.length
                            ? mixedData.map((result, key) => {
                                return (
                                  <li className="" key={key}>
                                    <div className="positionindex">
                                      <div className="img_text">
                                        <img src={result?.image} alt="" />{" "}
                                        {result?.name
                                          ? result?.name
                                          : result?.pair}
                                      </div>
                                      <div className="tradeMarkets_table0">
                                        {result?.open}
                                      </div>
                                      <div className="tradeMarkets_table0">
                                        {result?.close}
                                      </div>
                                      <div className="">
                                        <i
                                          className={`fa-solid ${
                                            result?.isUp
                                              ? "fa-caret-up green_text"
                                              : "fa-caret-down red_text"
                                          }`}
                                        ></i>{" "}
                                        {result?.percentageChange}%
                                      </div>
                                      <div className="Trend_img">
                                        <svg
                                          width="84"
                                          height="37"
                                          viewBox="0 0 84 37"
                                          fill="none"
                                        >
                                          <path
                                            d={result?.sparkline?.path}
                                            fill="none"
                                            stroke={
                                              result?.sparkline?.strokeColor
                                            }
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                          />

                                          <path
                                            d={`${result?.sparkline?.path} L84 37 L0 37 Z`}
                                            fill={`url(#${result?.sparkline?.gradientId})`}
                                            opacity="0.2"
                                          />

                                          <defs>
                                            <linearGradient
                                              id={result?.sparkline?.gradientId}
                                              x1="0"
                                              y1="0"
                                              x2="0"
                                              y2="1"
                                            >
                                              <stop
                                                offset="0%"
                                                stopColor={
                                                  result?.sparkline?.strokeColor
                                                }
                                              />
                                              <stop
                                                offset="100%"
                                                stopColor={
                                                  result?.sparkline?.strokeColor
                                                }
                                                stopOpacity="0"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                        {/* <img
                                          src={
                                            result?.isUp
                                              ? trendupimg
                                              : trenddownimg
                                          }
                                          alt=""
                                          className=""
                                        /> */}
                                      </div>
                                      <div className="">
                                        <Link
                                          className="btn site_grdbtn"
                                          to={
                                            token
                                              ? `${base_url}userdashboard`
                                              : `${base_url}login`
                                          }
                                          state={
                                            token
                                              ? { from: "real_account" }
                                              : ""
                                          }
                                        >
                                          {t("Trade Now")}
                                        </Link>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })
                            : ""}
                        </ul>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="profile"
                      role="tabpanel"
                      aria-labelledby="profile-tab"
                    >
                      <div className="table-responsive">
                        <ul className="tradeMarkets_table_list">
                          {cryptoData?.length
                            ? cryptoData.map((result, key) => {
                                return (
                                  <li className="" key={key}>
                                    <div className="positionindex">
                                      <div className="img_text">
                                        <img src={result?.image} alt="" />{" "}
                                        {result?.name}
                                      </div>
                                      <div className="tradeMarkets_table0">
                                        {result?.open}
                                      </div>
                                      <div className="tradeMarkets_table0">
                                        {result?.close}
                                      </div>
                                      <div className="">
                                        <i
                                          className={`fa-solid ${
                                            result?.isUp
                                              ? "fa-caret-up green_text"
                                              : "fa-caret-down red_text"
                                          }`}
                                        ></i>{" "}
                                        {result?.percentageChange}%
                                      </div>
                                      <div className="Trend_img">
                                        <svg
                                          width="84"
                                          height="37"
                                          viewBox="0 0 84 37"
                                          fill="none"
                                        >
                                          <path
                                            d={result?.sparkline?.path}
                                            fill="none"
                                            stroke={
                                              result?.sparkline?.strokeColor
                                            }
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                          />

                                          <path
                                            d={`${result?.sparkline?.path} L84 37 L0 37 Z`}
                                            fill={`url(#${result.sparkline.gradientId}crypto)`}
                                            opacity="0.2"
                                          />

                                          <defs>
                                            <linearGradient
                                              id={`${result?.sparkline?.gradientId}crypto`}
                                              x1="0"
                                              y1="0"
                                              x2="0"
                                              y2="1"
                                            >
                                              <stop
                                                offset="0%"
                                                stopColor={
                                                  result?.sparkline?.strokeColor
                                                }
                                              />
                                              <stop
                                                offset="100%"
                                                stopColor={
                                                  result?.sparkline?.strokeColor
                                                }
                                                stopOpacity="0"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                        {/* <img
                                          src={
                                            result?.isUp
                                              ? trendupimg
                                              : trenddownimg
                                          }
                                          alt=""
                                          className=""
                                        /> */}
                                      </div>
                                      <div className="">
                                        <Link
                                          className="btn site_grdbtn"
                                          to={
                                            token
                                              ? `${base_url}userdashboard`
                                              : `${base_url}login`
                                          }
                                          state={
                                            token
                                              ? { from: "real_account" }
                                              : ""
                                          }
                                        >
                                          {t("Trade Now")}
                                        </Link>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })
                            : ""}
                        </ul>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="contact"
                      role="tabpanel"
                      aria-labelledby="contact-tab"
                    >
                      <div className="table-responsive">
                        <ul className="tradeMarkets_table_list">
                          {forexData?.length
                            ? forexData.map((result, key) => {
                                return (
                                  <li className="" key={key}>
                                    <div className="positionindex">
                                      <div className="img_text">
                                        <img src={result?.image} alt="" />{" "}
                                        {result?.pair}
                                      </div>
                                      <div className="tradeMarkets_table0">
                                        {result?.open}
                                      </div>
                                      <div className="tradeMarkets_table0">
                                        {result?.close}
                                      </div>
                                      <div className="">
                                        <i
                                          className={`fa-solid ${
                                            result?.isUp
                                              ? "fa-caret-up green_text"
                                              : "fa-caret-down red_text"
                                          }`}
                                        ></i>{" "}
                                        {result?.percentageChange}%
                                      </div>
                                      <div className="Trend_img">
                                        <svg
                                          width="84"
                                          height="37"
                                          viewBox="0 0 84 37"
                                          fill="none"
                                        >
                                          <path
                                            d={result?.sparkline?.path}
                                            fill="none"
                                            stroke={
                                              result?.sparkline?.strokeColor
                                            }
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                          />

                                          <path
                                            d={`${result?.sparkline?.path} L84 37 L0 37 Z`}
                                            fill={`url(#${result?.sparkline?.gradientId}forex)`}
                                            opacity="0.2"
                                          />

                                          <defs>
                                            <linearGradient
                                              id={`${result?.sparkline?.gradientId}forex`}
                                              x1="0"
                                              y1="0"
                                              x2="0"
                                              y2="1"
                                            >
                                              <stop
                                                offset="0%"
                                                stopColor={
                                                  result?.sparkline?.strokeColor
                                                }
                                              />
                                              <stop
                                                offset="100%"
                                                stopColor={
                                                  result?.sparkline?.strokeColor
                                                }
                                                stopOpacity="0"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                        {/* <img
                                          src={
                                            result?.isUp
                                              ? trendupimg
                                              : trenddownimg
                                          }
                                          alt=""
                                          className=""
                                        /> */}
                                      </div>
                                      <div className="">
                                        <Link
                                          className="btn site_grdbtn"
                                          to={
                                            token
                                              ? `${base_url}userdashboard`
                                              : `${base_url}login`
                                          }
                                          state={
                                            token
                                              ? { from: "real_account" }
                                              : ""
                                          }
                                        >
                                          {t("Trade Now")}
                                        </Link>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })
                            : ""}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Trade the Markets You Love start */}
        {/* Why Choose start */}
        <section className="whyChoose_Sec">
          <div className="container">
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-3 col-md-3 col-sm-4">
                <div
                  className="leftAnimation1"
                  onMouseEnter={() => handleMouseEnter("leftAnimation01")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="whyChoose_box">
                    <div className="overhidden">
                      <div className="why_htex">
                        <h5>
                          <BreakText
                            text={
                              homepagedata?.whyChooseSection[0]?.content?.title
                            }
                            breakAt={3}
                          />
                          {/* Easy Deposits and
                        <br />
                        Withdrawals */}
                        </h5>
                        <p>
                          {
                            homepagedata?.whyChooseSection[0]?.content
                              ?.description
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="leftAnimation2"
                  onMouseEnter={() => handleMouseEnter("leftAnimation02")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="whyChoose_box ml25">
                    <div className="overhidden">
                      <div className="why_htex">
                        <h5>
                          <BreakText
                            text={
                              homepagedata?.whyChooseSection[1]?.content?.title
                            }
                            breakAt={2}
                          />
                          {/* High Customer
                        <br />
                        Loyalty */}
                        </h5>
                        <p>
                          {
                            homepagedata?.whyChooseSection[1]?.content
                              ?.description
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="leftAnimation3"
                  onMouseEnter={() => handleMouseEnter("leftAnimation03")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="whyChoose_box ml25">
                    <div className="overhidden">
                      <div className="why_htex">
                        <h5>
                          <BreakText
                            text={
                              homepagedata?.whyChooseSection[2]?.content?.title
                            }
                            breakAt={1}
                          />
                          {/* Trading
                        <br />
                        Advantages */}
                        </h5>
                        <p>
                          {
                            homepagedata?.whyChooseSection[2]?.content
                              ?.description
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="leftAnimation4"
                  onMouseEnter={() => handleMouseEnter("leftAnimation04")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="whyChoose_box">
                    <div className="overhidden">
                      <div className="why_htex">
                        <h5>
                          <BreakText
                            text={
                              homepagedata?.whyChooseSection[3]?.content?.title
                            }
                            breakAt={2}
                          />
                          {/* Indicators and
                        <br />
                        Signals */}
                        </h5>
                        <p>
                          {
                            homepagedata?.whyChooseSection[3]?.content
                              ?.description
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-6 col-sm-4">
                <div className="sec_title text-center position-relative">
                  <img src={whychoosebgimg} className="choose_bg_img" alt="" />
                  <img
                    src={whychoosecolor}
                    className={`choose_bg_color ${activeAnimation}`}
                    alt=""
                  />
                  <h2 className="block_title">
                    {homepagedata?.whyChooseSection[0]?.title?.title}
                  </h2>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-4">
                <div
                  className="leftAnimation5"
                  onMouseEnter={() => handleMouseEnter("leftAnimation05")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="whyChoose_box">
                    <div className="overhidden">
                      <div className="why_htex">
                        <h5>
                          <BreakText
                            text={
                              homepagedata?.whyChooseSection[4]?.content?.title
                            }
                            breakAt={1}
                          />
                          {/* Flexible
                        <br />
                        Trading */}
                        </h5>
                        <p>
                          {
                            homepagedata?.whyChooseSection[4]?.content
                              ?.description
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="leftAnimation6"
                  onMouseEnter={() => handleMouseEnter("leftAnimation06")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="whyChoose_box mr25">
                    <div className="overhidden">
                      <div className="why_htex">
                        <h5>
                          <BreakText
                            text={
                              homepagedata?.whyChooseSection[5]?.content?.title
                            }
                            breakAt={1}
                          />
                          {/* Comprehensive
                        <br />
                        Education */}
                        </h5>
                        <p>
                          {
                            homepagedata?.whyChooseSection[5]?.content
                              ?.description
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="leftAnimation7"
                  onMouseEnter={() => handleMouseEnter("leftAnimation07")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="whyChoose_box mr25">
                    <div className="overhidden">
                      <div className="why_htex">
                        <h5>
                          <BreakText
                            text={
                              homepagedata?.whyChooseSection[6]?.content?.title
                            }
                            breakAt={2}
                          />
                          {/* Diverse Trading
                        <br />
                        Instruments */}
                        </h5>
                        <p>
                          {
                            homepagedata?.whyChooseSection[6]?.content
                              ?.description
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="leftAnimation8"
                  onMouseEnter={() => handleMouseEnter("leftAnimation08")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="whyChoose_box">
                    <div className="overhidden">
                      <div className="why_htex">
                        <h5>
                          <BreakText
                            text={
                              homepagedata?.whyChooseSection[7]?.content?.title
                            }
                            breakAt={1}
                          />
                          {/* Demo
                        <br />
                        account */}
                        </h5>
                        <p>
                          {
                            homepagedata?.whyChooseSection[7]?.content
                              ?.description
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Why Choose end */}
        {/* Stock Market start */}
        <section className="stockMarket_sec">
          <div className="container topBorder">
            <div className="row">
              <div className="col-xl-12">
                <div className="sec_title text-left">
                  <h2 className="block_title">
                    {homepagedata?.masterStockSection[0]?.title?.title}
                  </h2>
                  <p>
                    {homepagedata?.masterStockSection[0]?.subtitle?.description}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div className="stockMarket_box">
                  <figure>
                    <img
                      src={
                        base_image_url +
                        homepagedata?.masterStockSection[0]?.content?.image
                      }
                      alt="Stock Market"
                    />
                  </figure>
                  <div className="stockMarket_subtext">
                    <h5>
                      {homepagedata?.masterStockSection[0]?.content?.title}
                    </h5>
                    <p>
                      {
                        homepagedata?.masterStockSection[0]?.content
                          ?.description
                      }{" "}
                      <Link
                        to=""
                        onClick={(e) => e.preventDefault()}
                        className="icon"
                      >
                        <i className="fa-solid fa-arrow-right"></i>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div className="stockMarket_box">
                  <figure>
                    <img
                      src={
                        base_image_url +
                        homepagedata?.masterStockSection[1]?.content?.image
                      }
                      alt="Stock Market"
                    />
                  </figure>
                  <div className="stockMarket_subtext">
                    <h5>
                      {homepagedata?.masterStockSection[1]?.content?.title}
                    </h5>
                    <p>
                      {
                        homepagedata?.masterStockSection[1]?.content
                          ?.description
                      }{" "}
                      <Link
                        to=""
                        onClick={(e) => e.preventDefault()}
                        className="icon"
                      >
                        <i className="fa-solid fa-arrow-right"></i>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div className="stockMarket_box">
                  <figure>
                    <img
                      src={
                        base_image_url +
                        homepagedata?.masterStockSection[2]?.content?.image
                      }
                      alt="Stock Market"
                    />
                  </figure>
                  <div className="stockMarket_subtext">
                    <h5>
                      {homepagedata?.masterStockSection[2]?.content?.title}
                    </h5>
                    <p>
                      {
                        homepagedata?.masterStockSection[2]?.content
                          ?.description
                      }{" "}
                      <Link
                        to=""
                        onClick={(e) => e.preventDefault()}
                        className="icon"
                      >
                        <i className="fa-solid fa-arrow-right"></i>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Stock Market end */}
        {/* Trade on demo start */}
        <section
          className="trade_demo_sec"
          style={{ backgroundImage: `url(${traderegistrationbg})` }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-7 col-md-7">
                <div className="sec_title text-center">
                  <h2 className="block_title">
                    <span>{homepagedata?.demoTradeSection?.title?.title}</span>
                    {homepagedata?.demoTradeSection?.subtitle?.subtitle}
                  </h2>
                  <p>
                    {homepagedata?.demoTradeSection?.description?.description}
                  </p>
                </div>

                <div className="button_group">
                  <Link
                    className="btn site_grdbtn"
                    to={token ? `${base_url}userdashboard` : `${base_url}login`}
                    state={token ? { from: "real_account" } : ""}
                  >
                    {homepagedata?.demoTradeSection?.content?.button_first}{" "}
                  </Link>
                  <Link
                    className="btn site_grdbtn"
                    to={token ? `${base_url}userdashboard` : `${base_url}login`}
                    state={token ? { from: "real_account" } : ""}
                  >
                    {homepagedata?.demoTradeSection?.content?.button_second}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Trade on demo end */}
        {/* What people say about us start */}
        <section className="testimonialsSec">
          <div className="container">
            <div className="row position-relative align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-12">
                <div className="sec_title">
                  <img src={testimonialstitlebg} className="bgimg" alt="" />
                  <h2 className="block_title">
                    {t("What people say about us")}
                  </h2>
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-sm-12">
                <div className="testimonials_slider">
                  <Slider {...settings} className="testimonials_slick_slider">
                    {/* <div className="testimonials_slick_slider"> */}
                    {reviewdata?.length
                      ? reviewdata.map((result, key) => {
                          return (
                            <div className="slider_item" key={key}>
                              <div className="testimonials_box">
                                <div className="testimonials_inner">
                                  <div className="testimonials_dt">
                                    <div className="dtone">
                                      <img
                                        src={base_image_url + result?.image}
                                        alt=""
                                      />
                                      <h5 className="testnamepos">
                                        {result?.name}{" "}
                                        <small> {result?.location}</small>
                                      </h5>
                                    </div>
                                    <div className="star_ret">
                                      {[...Array(5)].map((_, i) => (
                                        <i
                                          key={i}
                                          style={{
                                            color: "#b9a122",
                                          }}
                                          className={
                                            i < parseInt(result.rating)
                                              ? "fa-solid fa-star"
                                              : "fa-regular fa-star"
                                          }
                                        ></i>
                                      ))}
                                      {/* <i className="fa-regular fa-star"></i>   */}
                                    </div>
                                  </div>
                                  <p>{result?.message}</p>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : ""}
                  </Slider>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* What people say about us end */}
        {/* Frequently asked questions start */}
        <section className="faq_sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-7 col-sm-12">
                <div className="accordion accordion_flex" id="accordionExample">
                  {homepagedata?.faqSection?.length
                    ? homepagedata?.faqSection.map((result, key) => {
                        return (
                          <div className="accordion-item">
                            <h2
                              className="accordion-header"
                              id={`accordion${key + 1}`}
                            >
                              <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                // data-bs-target="#collapse1"
                                aria-expanded="true"
                                aria-controls={`collapse${key + 1}`}
                                onClick={() =>
                                  handleToggleCollapse(
                                    `collapse${key + 1}`,
                                    setCollapseshow,
                                    true,
                                    null,
                                    false,
                                    true,
                                  )
                                }
                              >
                                {result?.title}{" "}
                                <span>
                                  {/* <i className={`fa-solid ${collapseshow?.collapse1 ? "fa-minus":"fa-plus"}`}></i> */}
                                  {collapseshow?.[`collapse${key + 1}`] ? (
                                    <i className="fas fa-minus"></i>
                                  ) : (
                                    <i className="fas fa-plus"></i>
                                  )}

                                  {/* <img src={minusicon} alt=''/> */}
                                </span>
                              </button>
                            </h2>
                            <div
                              id={`collapse${key + 1}`}
                              className="accordion-collapse collapse"
                              aria-labelledby={`accordion${key + 1}`}
                              data-bs-parent="#accordionExample"
                            >
                              <div
                                className="accordion-body"
                                dangerouslySetInnerHTML={{
                                  __html: result?.description?.replace(
                                    /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
                                    '<a href="mailto:$1">$1</a>',
                                  ),
                                }}
                              />
                              {/* <div className="accordion-body">
                                {result?.description}
                              </div> */}
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12">
                <div className="sec_title text-left">
                  <h2 className="block_title">
                    {t("Frequently asked questions")}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Frequently asked questions end  */}
        {/* <div
          className="modal fade"
          id="installAppModal"
          tabIndex="-1"
          aria-labelledby="installAppLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="installAppLabel">
                  Confirm
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <p className="text-white m-0">
                  Would you like to add Equlix to your home screen?
                </p>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn border_btn"
                  data-bs-dismiss="modal"
                >
                  No
                </button>

                <button
                  type="button"
                  className="btn bg_btn"
                  onClick={() => handleInstall()}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div> */}

        <Footer />
      </div>
    </div>
  );
};

export default Home;
